import { useEffect } from "react";

import { capitalize } from "neetocist";
import { Dropdown } from "neetoui";
import { prop, values } from "ramda";
import { useTranslation } from "react-i18next";

import CustomDatePicker from "./CustomDatePicker";

const Header = ({
  calendarRef,
  selectedView,
  setSelectedView,
  setSelectedDate,
  selectedDate,
  calendarViewOptions,
  validDates,
}) => {
  const { t } = useTranslation();
  const { Menu, MenuItem } = Dropdown;

  const handleViewSelection = option => {
    setSelectedView(option);
    calendarRef.current.calendar.changeView(option.fullCalendarView);
  };

  const navigateToSelectedDate = () =>
    calendarRef?.current?.calendar?.gotoDate(selectedDate.format("YYYY-MM-DD"));

  useEffect(() => {
    setTimeout(navigateToSelectedDate);
  }, [selectedDate]);

  return (
    <div
      aria-label={t("neetoMolecules.calendarView.aria.calendarControls")}
      className="flex gap-x-4"
      role="group"
    >
      <CustomDatePicker
        {...{ selectedDate, setSelectedDate, validDates }}
        getPopupContainer={prop("parentNode")}
        picker={selectedView.picker}
      />
      {Object.keys(calendarViewOptions).length > 1 && (
        <Dropdown
          buttonStyle="secondary"
          label={capitalize(selectedView.label)}
          buttonProps={{
            "data-testid": "calendar-view-dropdown",
            "aria-label": t("neetoMolecules.calendarView.aria.viewSelector", {
              view: capitalize(selectedView.label),
            }),
          }}
        >
          <Menu>
            {values(calendarViewOptions).map((option, idx) => (
              <MenuItem.Button
                isActive={selectedView === option}
                key={idx}
                onClick={() => handleViewSelection(option)}
              >
                {capitalize(option.label)}
              </MenuItem.Button>
            ))}
          </Menu>
        </Dropdown>
      )}
    </div>
  );
};

export default Header;
